// axios
import axios from 'axios'
import { environment } from '../package.json'

const baseURL_DESA =
  'http://132.145.208.198:9073/WSRestAppTime2Change-APP/webresources/WSRestAppTime2Change'
const baseURL_PRUE =
  'http://132.145.208.198:9073/WSRestAppTime2Change-APP/webresources/WSRestAppTime2Change'
const baseURL_PRUE2 =
  'http://132.145.208.198:80/WSRestAppTime2Change-APP/webresources/WSRestAppTime2Change'
const baseURL_PRUE3 =
  'https://t2c-qa.arqbs.com/WSRestAppTime2Change-APP/webresources/WSRestAppTime2Change' // Último WS de pruebas
const baseURL_PROD =
  'https://t2c.arqbs.com/WSRestAppTime2Change-APP/webresources/WSRestAppTime2Change'
const baseURL_PROD_V2 =
  'https://t2c-prd.saas.arqbs.com/WSRestAppTime2Change-APP/webresources/WSRestAppTime2Change'
const baseURL_LOCALHOST =
  'http://localhost:8080/WSRestAppTime2Change-APP/webresources/WSRestAppTime2Change'

let baseURL = ''

switch (environment) {
  case 'PRD':
    baseURL = baseURL_PROD
    break
  case 'SQA':
    baseURL = baseURL_PRUE3
    break
  case 'DEV':
    baseURL = baseURL_DESA
    break
  case 'LOCALHOST':
    baseURL = baseURL_LOCALHOST
  default:
    break
}

export default axios.create({
  baseURL,
  // You can add your headers here
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
    'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers'
  },
  withCredentials: false
})
